import { render } from "./TermsOfServie.vue?vue&type=template&id=2779c53f"
import script from "./TermsOfServie.vue?vue&type=script&lang=js"
export * from "./TermsOfServie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__